module.exports = __webpack_public_path__ + "img/mit-PV.b6f3ba42.png";